
import React, { useCallback, useRef, useState } from "react";
import { Button } from "./Elements";
import { useSelector } from "react-redux";

export const AnsweredUnreviewed = ({
  display,
  questions = [],
  socketRef,
  liveEvent,
  setQuestions,
  height,
}) => {
  const { token, activeUser } = useSelector((state) => state.users);
  const event_id = liveEvent?.public_id ?? liveEvent?.id;
  const [editAnswer, setEditAnswer] = useState(null);
  const divHeights = useRef({})

  const setDivRef = useCallback((id, el) => {
    if (el) {
      divHeights.current[id] = el.offsetHeight;
    }
  }, [])

  return (
    <div
      style={{
        display: display ? "block" : "none",
        paddingTop: "20px",
        paddingLeft: "20px",
        height: height,
        overflow: "auto",
      }}
    >
      <ul>
        {questions.length > 0 ? (
          questions
            .filter((q) => q.response && q.status === "awaiting response approval")
            .sort((a, b) => b.relevance - a.relevance)
            .map((question, index) => (
              <li
                key={index}
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                  width: "98%",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  padding: "5px 10px",
                  flexDirection: "column",
                }}
              >
                <div>{question?.message}</div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#808080",
                    fontStyle: "italic",
                  }}
                >
                  From: {question?.user.nickname}
                </div>
                <div style={{ width: "100%" }}>Answer:
                {editAnswer && editAnswer.public_id === question.public_id ?
                    <div style={{ marginTop: "5px", width: "100%" }}>
                      <textarea
                        value={editAnswer.response}
                        autoFocus
                        onChange={(e) =>
                          setEditAnswer({ ...editAnswer, response: e.target.value })
                        }
                        style={{ width: "100%", padding: "5px", backgroundColor: "--var(main-bg-color)", color: "--var(main-text-color)", borderRadius: "5px", border: "1px solid #ccc", height: divHeights.current[question.public_id] ? divHeights.current[question.public_id] + 40 : "auto" }}
                      />
                    </div> :
                    <div
                      ref={(el) => setDivRef(question.public_id, el)}
                    >{question?.response || "No answer provided."}</div>
                  }
                </div>
                <div>Answer Source: {question?.response_source || "N/A"}</div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  {
                    editAnswer && editAnswer.public_id === question.public_id ?
                      <>

                        <Button
                          bgcolor="#4CAF50"
                          textcolor="#fff"
                          onClick={() => {
                            // Handle answer submission logic here
                            console.log("Answer submitted for question:", question);
                            question.response = editAnswer.response;
                            question.responded_at = new Date().toISOString();
                            question.response_by = `${activeUser?.firstname} ${activeUser?.lastname}`; // Replace with actual user ID if needed
                            question.response_source = "agent";
                            question.status = "answered";
                            setQuestions((prevQuestions) =>
                              prevQuestions.map((q) =>
                                q.public_id === question.public_id
                                  ? {
                                    ...q,
                                    status: "answered",
                                    response: editAnswer.response,
                                    response_source: "agent",
                                    responded_at: new Date().toISOString(),
                                    response_by: {
                                      firstname: activeUser?.firstname,
                                      lastname: activeUser?.lastname,
                                      email: activeUser?.email,
                                    },
                                  }
                                  : q
                              )
                            );

                            socketRef.current.emit("update-message-response", {
                              event_id: event_id,
                              broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                              message_id: question.public_id,
                              status: "answered",
                              response: editAnswer.response,
                              response_by: activeUser?.public_id, // Replace with actual user ID if needed
                              response_source: "agent",
                              response_approved_by: activeUser?.public_id, // Replace with actual user ID if needed
                              token: token,
                            });
                            setEditAnswer(null);
                          }}
                        >
                          Submit Answer
                        </Button>
                        <Button
                          bgcolor="#f44336"
                          textcolor="#fff"
                          onClick={() => setEditAnswer(null)}
                        >
                          Cancel
                        </Button>
                      </>

                      :
                      <>
                        <Button
                          bgcolor="#dcfce8"
                          textcolor="#16a34a"
                          onClick={() => {
                            console.log("!!! APPROVING ANSWER: ", question);
                            socketRef.current.emit("update-message-status", {
                              event_id: event_id,
                              broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                              message_id: question.public_id,
                              status: "answered",
                              response: question.response,
                              response_approved_by: activeUser?.public_id, // Replace with actual user ID if needed
                              token: token,
                            });
                            setQuestions((prevQuestions) =>
                              prevQuestions.map((q) =>
                                q.public_id === question.public_id
                                  ? { ...q, status: "answered" }
                                  : q
                              )
                            );
                          }}
                        >
                          <i className="fas fa-check-circle"></i>
                        Approve Agent Answer
                      </Button>
                        <Button
                          bgcolor="#f3f4f6"
                          textcolor="#334155"
                          onClick={(e) => {
                            console.log("!!! REPLYING TO QUESTION: ", question);
                            setEditAnswer(question);
                          }}
                        >
                          <i className="fas fa-reply"></i>
                          Edit Agent Answer
                      </Button>
                        <Button
                          bgcolor="#f87171"
                          textcolor="#ffffff"
                          onClick={() => {
                            socketRef.current.emit("update-message-status", {
                              token: token,
                              event_id: event_id,
                              broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                              message_id: question.public_id,
                              status: "approved",
                              response: null,
                            });
                            setQuestions((prevQuestions) =>
                              prevQuestions.map((q) =>
                                q.public_id === question.public_id
                                  ? { ...q, status: "approved", response: null, response_source: null, responded_at: null, response_by: null }
                                  : q
                              )
                            );
                          }}
                        >
                          <i className="fas fa-check-circle"></i>
                    Unanswer
                    </Button>
                      </>
                  }
                </div>
              </li>
            ))
        ) : (
          <li>No questions available.</li>
        )}
      </ul>
    </div>
  );
};

export default AnsweredUnreviewed;
